import { createSlice } from '@reduxjs/toolkit';
import { setPrompt } from './promptSlice';

export const createImageSlice = createSlice({
  name: 'createImage',
  initialState: {
    generatedImages: [],
    isImageLoading: false,
    isImageError: false,
    errorImageMessage: '',
    isVisualizePageVisible: true,
    lastPayload: null,
    promptBoxFocus: false
  },
  reducers: {
    setIsVisualizePageVisible: (state, action) => {
      state.isVisualizePageVisible = action.payload;
    },
    setImageLoading: (state, action) => {
      state.isImageLoading = action.payload;
      state.isImageError = false;
      state.errorImageMessage = '';
    },
    setGeneratedImages: (state, action) => {
      state.generatedImages = [action.payload, ...state.generatedImages];
      state.isImageLoading = false;
      state.isImageError = false;
      state.errorImageMessage = '';
    },
    setImageError: (state, action) => {
      state.isImageError = true;
      state.errorImageMessage = action.payload;
      state.isImageLoading = false;
    },
    resetErrorState: (state) => {
      state.isImageError = false;
      state.errorImageMessage = '';
    },
    setEmptyGeneratedImages: (state) => {
      state.generatedImages = [];
    },
    updateGeneratedImagesFromPastCreation: (state, action) => {
      const { images } = action.payload;
      state.generatedImages = images;
    },
    setLastPayload: (state, action) => {
      state.lastPayload = action.payload;
    },
    updateGeneratedImageFeedback(state, action) {
      const { feedbackData } = action.payload;

      const imageToUpdate = state.generatedImages.find((image) => image._id === feedbackData._id);

      if (!imageToUpdate) return;

      if (imageToUpdate) {
        imageToUpdate.comment = feedbackData.comment;
        imageToUpdate.feedback1 = feedbackData.feedback1;
        imageToUpdate.feedback2 = feedbackData.feedback2;
        imageToUpdate.feedback3 = feedbackData.feedback3;
        imageToUpdate.rating = feedbackData.rating;
      } else {
        console.error('Image not found for the provided _id:', feedbackData._id);
      }
    },
    setPromptBoxFocus: (state, action) => {
      state.promptBoxFocus = action.payload;
    }
  }
});

export const {
  setIsVisualizePageVisible,
  setImageLoading,
  setImageError,
  setGeneratedImages,
  resetErrorState,
  setEmptyGeneratedImages,
  setLastPayload,
  updateGeneratedImageFeedback,
  updateGeneratedImagesFromPastCreation,
  setPromptBoxFocus
} = createImageSlice.actions;

export default createImageSlice.reducer;
